import { Chip } from '@mui/material'
import { styles } from './styles'
import type { EmployeeStatusProps } from './types'

export const EmployeeStatus = ({ status }: EmployeeStatusProps) => {
  switch (status) {
    case 'DRAFT':
      return (
        <Chip
          sx={{
            ...styles.chip,
            color: '#787878',
            borderColor: '#8E8E8E',
            backgroundColor: '#EEEEEE',
          }}
          variant={'outlined'}
          label={'Черновик'}
        />
      )
    case 'Черновик':
      return (
        <Chip
          sx={{
            ...styles.chip,
            color: '#787878',
            borderColor: '#8E8E8E',
            backgroundColor: '#EEEEEE',
          }}
          variant={'outlined'}
          label={'Черновик'}
        />
      )
    case 'INVITE':
      return (
        <Chip
          sx={{
            ...styles.chip,
            background: '#EAF8FF',
            borderColor: '#009FDA',
            color: '#009FDA',
          }}
          variant={'outlined'}
          label={'Приглашен'}
        />
      )
    case 'CONFIRMED':
      return (
        <Chip
          sx={styles.chip}
          variant={'outlined'}
          color="success"
          label={'Допущен'}
        />
      )
    case 'FIRED':
      return (
        <Chip
          sx={styles.chip}
          variant={'outlined'}
          color="error"
          label={'Уволен'}
        />
      )
    case 'BLOCKED':
      return (
        <Chip
          sx={styles.chip}
          variant={'outlined'}
          color="warning"
          label={'Заблокирован'}
        />
      )
    case 'DELETED':
      return (
        <Chip
          sx={styles.chip}
          variant={'outlined'}
          color="error"
          label={'Удален'}
        />
      )
    default:
      return (
        <Chip
          sx={styles.chip}
          variant={'outlined'}
          color="primary"
          label={'...'}
        />
      )
  }
}
